import { styled } from "@mui/material/styles"

import { BottomSheet as UiBottomSheet } from "../BottomSheet"

export const BottomSheet = styled(UiBottomSheet, {
    shouldForwardProp: (prop) => prop !== "height",
})(({ height }) => ({
    height: `${height}% !important`,
    position: "absolute",
    top: `${100 - height}% !important`,

    "& .MuiDrawer-paper": {
        height: "100% !important",
        maxHeight: "100% !important",
        position: "relative",
        transform: "translateY(0) !important",
        width: "100%",
        overflowY: "hidden",
    },
}))